import { AcornsIcon } from '@acorns/icons'
import { Button, theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT, fonts } from '../styles'

export const Container = styled.div`
  align-items: center;
  background: ${theme.colors.charcoal};
  display: flex;
  height: 84px;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 80px;
  width: 100%;
  z-index: 39;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    top: 70px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    height: 66px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin: auto;
  padding: 20px;
  width: 100%;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    width: 100%;
  }
`

export const TitleBarItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`

export const Title = styled.h1`
  ${fonts.AN_16_600_24}
  color: ${theme.colors.white};
  text-align: center;
`

export const BackButton = styled.div`
  display: flex;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
`

export const ShareButton = styled(Button)`
  margin-left: auto;
  border: none;

  path {
    fill: ${theme.colors.white};
  }

  div {
    margin-left: 10px;
  }
`

export const ShareButtonText = styled.span`
  margin-left: 10px;
`

export const StyledCloseIcon = styled(AcornsIcon)`
  margin-right: auto;
  cursor: pointer;
`

export const StyledLeafIcon = styled(AcornsIcon)`
  margin-left: auto;
  cursor: pointer;

  path {
    fill: ${theme.colors.white};
  }
`
